import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    imageStyleEn,
    imageStyleFr,
    imageStylePor,
    imageStyleDu,
    imageStyleGr,
    imageStyleIt,
    imageStyleSp,
} from './Fa.ve.css';

const styleMap = {
    'en-US': imageStyleEn,
    'fr-FR': imageStyleFr,
    'de-DE': imageStyleGr,
    es: imageStyleSp,
    'pt-BR': imageStylePor,
    'it-IT': imageStyleIt,
    'nl-NL': imageStyleDu,
};

export const Fa = () => {
    const { locale } = getContext();
    const style = styleMap[locale] || imageStyleEn;
    return <span className={style} />;
};
